import { createSelector } from 'reselect'

import { getCallsActiveLookup } from '../actives/selectors'
import {
  getApiCallParticipants,
  getApiCalls,
  getApiTopics,
} from '../api/selectors'
import { getCurrentTeammateHandle } from '../current/selectors'

export const getActiveCallForCurrentMember = createSelector(
  [getCurrentTeammateHandle, getCallsActiveLookup, getApiCalls],
  (currentTeammateHandle, lookup, calls) => {
    const id = lookup?.handles?.[currentTeammateHandle]?.[0]
    return calls?.[id]
  },
)

export const getActiveCallParticipantForCurrentMember = createSelector(
  [getCurrentTeammateHandle, getCallsActiveLookup, getApiCallParticipants],
  (currentTeammateHandle, lookup, callParticipants) => {
    const callId = lookup?.handles?.[currentTeammateHandle]?.[0]
    return (
      callId &&
      Object.values(callParticipants).find(
        (p) => p.handle === currentTeammateHandle && p.call_id === callId,
      )
    )
  },
)

export const makeIsTopicActive = () =>
  createSelector(
    [getCallsActiveLookup, (_, topicId) => topicId],
    (lookup, topicId) => {
      return !!lookup?.topics?.[topicId]?.[0]
    },
  )

export const getActiveCallIdsOnAccount = createSelector(
  [getCallsActiveLookup],
  (lookup) => {
    return Object.values(lookup?.topics || {})
      .map((val) => val[0])
      .filter((val) => !!val)
  },
)

export const getOpenCallsData = createSelector(
  [getCallsActiveLookup, getApiTopics, getCurrentTeammateHandle],
  (lookup, topics, currentHandle) => {
    return Object.entries(lookup?.topics || {}).reduce(
      (acc, [topicId, val]) => {
        const callId = val[0]
        if (callId) {
          const topic = topics[topicId]
          if (!topic) {
            return acc
          }
          const directChatHandle =
            topic.contact_handles &&
            topic.contact_handles.find((handle) => handle !== currentHandle)
          acc = [
            ...acc,
            {
              topicId: parseInt(topicId, 10),
              directChatHandle: directChatHandle,
            },
          ]
        }
        return acc
      },
      [],
    )
  },
)
